<div class="float-drag" cdkDrag>
	<div class="float-container" cdkDragHandle>
        <div class="float-header" >
			<div class="header-text">Address Association Wizard</div>
			<i class="glyphicons glyphicons-remove" (click)="close()"></i>
        </div>
	
		<div class="wizard-content-wrap-columns">
			<div class="wizard-step-container">
				<ng-container *ngFor="let step of steps">
					<div *ngIf="step.num <= currentStep.num" [@fadeInOut] [ngClass]="{'step-title-line': step.isSameLine}">
						<app-wizard-step-title [stepNum]="step.num" [stepLabel]="step.label" [isCurrent]="step.num===currentStep.num"></app-wizard-step-title>
						<div *ngIf="step.num===1" class="step-detail">
							<select name="fbFilter" [(ngModel)]="fbFilter" (ngModelChange)="onChangeFbFilter()">
								<option *ngFor="let op of fbFilters" [ngValue]="op">{{op.label}}</option>
							</select>
						</div>
					</div>
				</ng-container>
			</div>
	
			<div class="wizard-button-groups">
				<div style="flex-grow:1;margin-bottom: 10px;">
					<button class="button-general button-small" (click)="cancel()">Cancel</button>
				</div>
				<button disabled="{{currentStep.isFirst}}" class="button-general button-small" (click)="goPrev()">Prev</button>
				<button class="button-general button-small" [disabled]="checkGoNextDisabled(currentStep.prop)" (click)="goNext()">{{currentStep.isLast ? 'Add Cards' :  'Next'}}</button>
			</div>
		</div>
	</div>
</div>

<!-- <div *ngIf="step.num===1" class="step-detail">
	<div class="relocate-options same-line">
		<div class="same-line">
			<input name="relocateMode" type="radio" value="sameStreet" [(ngModel)]="relocateMode" (ngModelChange)="onChangeRelocateMode()">
			<div>Same Street</div>
		</div>
		<div class="same-line">
			<input name="relocateMode" type="radio" value="diffStreet" [(ngModel)]="relocateMode" (ngModelChange)="onChangeRelocateMode()">
			<div>Different Street</div>
		</div>
	</div>
	<div class="same-line">
		<input type="checkbox" name="keepAddress" [(ngModel)]="isKeepAddressNum" (ngModelChange)="onToggleIsKeepAddressNum()">
		<div>Keep Address Number</div>
	</div>
</div> -->